export type ClassValue = string | false | null | undefined;

/** Join conditional class names. Small enough not to warrant a dependency. */
export function cx(...values: ClassValue[]): string {
  return values
    .filter((value): value is string => typeof value === "string" && value !== "")
    .join(" ");
}
